var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFormatListBulletedIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M9 19v-2h12v2zm0-6v-2h12v2zm0-6V5h12v2zM5 20q-.824 0-1.413-.587A1.93 1.93 0 0 1 3 18q0-.824.587-1.413A1.93 1.93 0 0 1 5 16q.824 0 1.412.587Q7 17.176 7 18c0 .824-.196 1.02-.588 1.413A1.93 1.93 0 0 1 5 20m0-6q-.824 0-1.413-.588A1.93 1.93 0 0 1 3 12q0-.825.587-1.412A1.93 1.93 0 0 1 5 10q.824 0 1.412.588Q7 11.175 7 12t-.588 1.412A1.93 1.93 0 0 1 5 14m0-6q-.824 0-1.413-.588A1.93 1.93 0 0 1 3 6q0-.824.587-1.412A1.93 1.93 0 0 1 5 4q.824 0 1.412.588Q7 5.175 7 6q0 .824-.588 1.412A1.93 1.93 0 0 1 5 8"
}))));
export default SvgFormatListBulletedIcon;